import React from 'react'
import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'

import type { ServiceBusSettings } from './app'

interface Props {
    config: ServiceBusSettings
    onChange: (event: Event) => void
    validationState: (name: string) => void
    errorsFor: (name: string) => void
}

export default function Form({ config, onChange, validationState, errorsFor }: Props): JSX.Element {
    return (
        <div className="form-area">
            <div>
                <h3>{i18n('Cloud Azure Config')}</h3>
            </div>
            <FormGroup
                type="text"
                label={
                    <span>
                        {i18n('Connection String')} <abbr title="required"> *</abbr>
                    </span>
                }
                name="config.host"
                value={config.host}
                onChange={onChange}
                validationState={validationState('config.host')}
                hasFeedback
                help={errorsFor('config.host')}
            />
            <FormGroup
                type="text"
                label={
                    <span>
                        {i18n('Topic')} <abbr title="required"> *</abbr>
                    </span>
                }
                name="config.topic"
                value={config.topic}
                onChange={onChange}
                validationState={validationState('config.topic')}
                hasFeedback
                help={errorsFor('config.topic')}
            />
            <FormGroup
                type="text"
                label={
                    <span>
                        {i18n('Subscription')} <abbr title="required"> *</abbr>
                    </span>
                }
                name="config.subscription"
                value={config.subscription}
                onChange={onChange}
                validationState={validationState('config.subscription')}
                hasFeedback
                help={errorsFor('config.subscription')}
            />
            <FormGroup
                type="text"
                label={
                    <span>
                        {i18n('Collection name')}
                        <abbr title="required"> *{i18n('Do not use special characters and start with number')} </abbr>
                    </span>
                }
                name="config.typeField"
                value={config.typeField}
                onChange={onChange}
                validationState={validationState('config.typeField')}
                hasFeedback
                help={errorsFor('config.typeField')}
            />
        </div>
    )
}
